export const stringifySearchParams = (
  data: Record<string | number | symbol, unknown>
): string => {
  const urlParams = new URLSearchParams();

  for (const [key, value] of Object.entries(data)) {
    urlParams.set(key, String(value));
  }

  return urlParams.toString();
};
